// Step for welcoming the user after successful authentication

import React, { useMemo } from 'react';
import { AuthStepCard } from './AuthStepCard';
import { Button } from '@/components/ui/button';
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import AnimatedOdometerNumber from '@/components/common/AnimatedOdometerNumber';
import { ASSETS } from '@airhead-games/shared/configs';
import { getSignupLoons } from '@airhead-games/shared/utilities';
interface WelcomeStepProps {
  onContinue: () => void;
}

const WelcomeStep: React.FC<WelcomeStepProps> = ({ onContinue }) => {
  // The signup grant, not the balance: achievements earned during signup
  // (e.g. Connect Twitch) announce their own Loons after this step.
  const formattedGrant = useMemo(
    () => getSignupLoons().toLocaleString('en-US'),
    []
  );

  return (
    <AuthStepCard className="gap-0">
      <CardHeader className="justify-items-center gap-3 px-6 pt-6 text-center">
        <CardTitle className="text-2xl">You&apos;re all set!</CardTitle>
        <CardDescription className="max-w-md text-center text-sm leading-6">
          We&apos;ve added free Loons to your account to get you started. Ready
          to play?
        </CardDescription>
      </CardHeader>

      <CardContent className="flex flex-col items-center gap-8 px-6 pb-6 pt-5 text-center">
        <div className="flex items-center justify-center gap-4">
          <img
            src={ASSETS.loonLite}
            alt=""
            aria-hidden="true"
            className="size-20 object-contain"
          />
          <div className="text-5xl font-semibold tracking-tight text-card-foreground">
            <AnimatedOdometerNumber text={formattedGrant} />
          </div>
        </div>

        <Button type="button" size="xl" className="w-full" onClick={onContinue}>
          I&apos;m ready
        </Button>
      </CardContent>
    </AuthStepCard>
  );
};

export default WelcomeStep;
